// extracted by mini-css-extract-plugin
export default {"section":"reviews_section__Zn-Py","header":"reviews_header__GQFXq","title":"reviews_title__gwzFU","text":"reviews_text__TSQE3"};